import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../store/pseudo/general';
import { styleMapping } from "../utils/tools";
import Menu from './menu';

class SideMenu extends React.Component {
    
    // ############################ RENDER ###################################
    // ############################ RENDER ###################################
    render() {
        const {settings } = this.props;
        if (!settings || !settings.logo || !settings.logo.title) {
            return null;
        }
        const brandTitle = (settings && settings.logo && settings.logo.title && settings.logo.title.text ? settings.logo.title.text : 'Strangers');
        
        return ( 
            <div className={"side-menu-shell"}>
                <div className="side-menu-header">
                    <button
                        type="button"
                        className={"side-menu-brand " + settings.logo.title.class}
                        style={styleMapping(settings.logo.title)}
                        onClick={this.handleHome}
                        aria-label="Go to home"
                    >
                        {brandTitle}
                    </button>
                    <button
                        type="button"
                        className="side-menu-close"
                        onClick={this.handleClose}
                        aria-label="Close menu"
                    >
                        x
                    </button>
                </div>

                <div className="side-menu-body">
                    <div className="side-menu-section-title">Navigate</div>
                    <div className="side-menu-list">
                        <Menu
                            onItemClick={this.handleClose}
                            forceVertical={true}
                            custom={{
                                container: "",
                                element: {
                                    class: 'side-menu-link-text',
                                    style: ''
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
        
    }
    
    // ############################ HANDLE HOME ###################################
    // ############################ HANDLE HOME ###################################
    handleHome = () => {
        this.props.navigate({direction: 'home'}, this.props.history);
        this.handleClose();
    }

    handleClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        } else {
            this.props.sideMenuFunction(false);
        }
    }
}

const mapstateToProps = (state) => {return {sideMenu: state.sideMenu,  isAuthenticated: state.status.token !== null && state.status.token !== '' ? true : false, status:state.status, user:state.user, settings:state.settings, architecture:state.architecture};}
const mapDispatchToProps = dispatch => {return {navigate: (direction, history) => dispatch(actions.navigate(direction, history)), onTryAutoSignup: (history) => dispatch(actions.authCheckState(history)), sideMenuFunction: (bVal) => dispatch(actions.sideMenu(bVal))}}
export default withRouter(connect(mapstateToProps, mapDispatchToProps)(SideMenu));
